import * as React from "react";
const SvgDescend = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, id: "arrow", ...props }, /* @__PURE__ */ React.createElement("g", { color: "#000" }, /* @__PURE__ */ React.createElement("path", { style: {
  isolation: "auto",
  mixBlendMode: "normal"
}, fill: "#cad1d8", d: "m-525 1402.362-10-13h5v-15h10v15h5l-10 13z", overflow: "visible", transform: "translate(541 -1372.362)" }), /* @__PURE__ */ React.createElement("path", { style: {
  isolation: "auto",
  mixBlendMode: "normal"
}, fill: "#25b39e", d: "m-525 1402.362-10-13h5v-7h10v7h5z", overflow: "visible", transform: "translate(541 -1372.362)" })));
export default SvgDescend;
